import { SupplierStorefrontV2GetResponseType } from "@sellar-io/api-v2/types";
import { CalculatedDeliveryOffer, calculateItemTotal } from "@sellar-io/common";
import { ReactElement } from "react";
import { twMerge } from "tailwind-merge";
import { BadgeLime } from "../../../../../../components/badge/Badge";
import { Card } from "@sellar-io/components";
import { ContextOrderBasketType } from "../../../../../../hooks";
import { ContainerTypeDeliveryChargeRulesSection } from "./components/ContainerTypeDeliveryChargeRulesSection";
import { SubtotalFreeDeliverySection } from "./components/SubtotalFreeDeliverySection";

export const StorefrontDeliveryOffersCard = ({
  className,
  supplierStorefront,
  calculatedDeliveryOffers,
  order,
}: {
  order: ContextOrderBasketType | null | undefined;
  className?: string;
  supplierStorefront: SupplierStorefrontV2GetResponseType | undefined;
  calculatedDeliveryOffers?: CalculatedDeliveryOffer[];
}): ReactElement | null => {
  const subtotalFreeDeliveryThreshold =
    supplierStorefront?.FulfillmentType.freeDeliveryBasketSubtotal ??
    supplierStorefront?.FulfillmentType.DeliveryChargeRules[0]?.value;
  const subtotal = calculateItemTotal(order?.OrderItems);

  const orderQualifiesForFreeDelivery =
    (!!subtotalFreeDeliveryThreshold || subtotalFreeDeliveryThreshold === 0) &&
    subtotal >= subtotalFreeDeliveryThreshold;

  const freeDeliveryRemainder = subtotalFreeDeliveryThreshold
    ? subtotalFreeDeliveryThreshold - subtotal
    : subtotalFreeDeliveryThreshold;

  const emptyBasket = freeDeliveryRemainder === subtotalFreeDeliveryThreshold;

  if (
    !calculatedDeliveryOffers?.length &&
    !supplierStorefront?.FulfillmentType.DeliveryChargeRules.length &&
    !supplierStorefront?.FulfillmentType.freeDeliveryBasketSubtotal
  ) {
    return null;
  }

  return (
    <>
      <Card
        className={twMerge("bg-white", "flex flex-col gap-2 p-4", className)}
      >
        <BadgeLime icon={"TRUCK"}>Delivery offers</BadgeLime>
        {subtotalFreeDeliveryThreshold !== undefined &&
          freeDeliveryRemainder !== undefined && (
            <SubtotalFreeDeliverySection
              qualifiesForFreeDelivery={orderQualifiesForFreeDelivery}
              freeDeliveryRemainder={freeDeliveryRemainder}
              emptyBasket={emptyBasket}
            />
          )}

        {!!calculatedDeliveryOffers?.length &&
          !orderQualifiesForFreeDelivery && (
            <ContainerTypeDeliveryChargeRulesSection
              calculatedDeliveryOffers={calculatedDeliveryOffers}
            />
          )}
      </Card>
    </>
  );
};
